export default __webpack_public_path__ + "static/media/cp1.eeda6ccc.jpg";